<template>
  <v-card flat id="clientRecords" class="mx-auto transparent" width="100%" max-width="500">
    <v-card-text v-if="getItems.length">
      <v-card flat v-if="getViewType === 'cards'" class="transparent">
        <template v-for="item in getItems">
          <Credit v-if="item.type === 'credit'"
            ref="item"
            class="mb-4"
            display="card"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Tutor v-else-if="item.type === 'tutor'"
            ref="item"
            class="mb-4"
            display="card"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Transfer v-else-if="item.type === 'transfer'"
            ref="item"
            class="mb-4"
            display="card"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Record v-else
            ref="item"
            class="mb-4"
            display="card"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
        </template>
      </v-card>
      <v-expansion-panels v-else-if="getViewType === 'items'">
        <template v-for="item in getItems">
          <Credit v-if="item.type === 'credit'"
            ref="item"
            display="item"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Tutor v-else-if="item.type === 'tutor'"
            ref="item"
            display="item"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Transfer v-else-if="item.type === 'transfer'"
            ref="item"
            display="item"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
          <Record v-else
            ref="item"
            display="item"
            :key="item.key"
            :item="item"
            :authors="getAuthors"
            @emit="emitted"
          />
        </template>
      </v-expansion-panels>
      <v-row dense>
        <v-col cols="12" class="mx-auto text-center">
          <v-btn v-if="!isEmpty || isLoading"
            color="white secondary--text"
            :loading="isLoading"
            :disabled="isFullLoaded"
            @click.stop="submit({ type: 'get' })">
            <v-icon small>{{ isFullLoaded ? 'fal fa-arrow-up' : 'fal fa-plus' }}</v-icon>&nbsp;{{ isFullLoaded ? '最初の投稿です' : 'さらに読み込む' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text v-else>
      <div class="d-flex justify-center headline">{{ isLoading ? 'データを取得中です...' : 'まだ 投稿がありません' }}</div>
    </v-card-text>
    <Editor ref="editor" @emit="emitted" />
    <Footer
      ref="footer"
      :types="meta.types"
      :status="config.status"
      :items="getItems"
      @search="search"
      @change="updateQuery"
    />
  </v-card>
</template>

<script>
// import Toolbars from './toolbars'
import Footer from './footer'
import Editor from './editor'
import Record from './posters/record'
import Credit from './posters/credit'
import Tutor from './posters/tutor'
import Transfer from './posters/transfer'
export default {
  name: 'clientRecords',
  components: {
    // Toolbars,
    Footer,
    Editor,
    Record,
    Credit,
    Tutor,
    Transfer
  },
  data () {
    return {
      config: {
        url: '',
        status: {
          authed: false,
          loading: false
        },
        editor: {
          active: false
        }
      },
      meta: {
        types: [
          { label: '全て', slug: 'record,tutor,credit,transfer' },
          { label: '対応履歴', slug: 'record'},
          { label: '個別指導', slug: 'tutor' },
          { label: 'カード決済', slug: 'credit' },
          { label: '海外送金', slug: 'transfer' }
        ]
      },
      form: {
        view: this.$vuetify.breakpoint.smAndUp ? 'cards' : 'items'
      },
      store: {
        items: [],
        count: 0,
        authors: {}
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$set(this.store, 'items', [])
      this.$set(this.store, 'count', 0)
      this.auth()
      this.submit({ type: 'get' })
      this.connectSocket()
      // this.$nextTick(() => {
      //   this.loadLegacy()
      // })
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push(`/client/${this.$route.params.id}/about`)
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    emitted: function (req) {
      const { action, data } = req || {}
      if (action && typeof this[action] === 'function') {
        this[action](data)
      }
    },
    preSubmit: function (req) {
      const { type, reset } = req
      const cid = this.$route.params.id
      const count = reset ? 0 : this.store.items.length
      const form = this.$refs.footer ? this.$refs.footer.getForm() : {}
      const postType = this.meta.types[form.type || 0] || { slug: '' }
      const urls = {
        get: `${this.$url.api}posts/get/items/${cid}`,
      }
      const fds = {
        get: Object.assign({}, form, { count, type: postType.slug.split(',') }),
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'get') {
          if (reset) {
            this.$set(this.store, 'items', [])
          }
        }
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'get') {
        this.store.items.push(...data.entries)
        this.$set(this.store, 'count', data.size)
        this.$set(this.config.status, 'loading', false)
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    search: function () {
      this.submit({ type: 'get', reset: true })
    },
    update: function (req) {
      const { action, item } = req
      const { id } = item
      const idx = this.store.items.findIndex(it => { return it.id === id })
      if (action === 'remove') {
        if (idx >= 0) {
          this.store.items.splice(idx, 1)
        }
      } else {
        if (idx >= 0) {
          this.store.items.splice(idx, 1, item)
          this.$nextTick(() => {
            if (this.$refs.item[idx] && this.$refs.item[idx].updated) {
              this.$refs.item[idx].updated()
            }
          })
        } else {
          this.store.items.push(item)
        }
      }
    },
    edit: function (item) {
      this.$refs.editor.open(item)
    },
    connectSocket: function () {
      const socket = this.$store.getters['config/get']('socket')
      const cid = this.$route.params.id
      const notifies = {
        insert: {
          title: '新しい投稿',
          message: `##AUTHOR##さんが新しい投稿をしました。`
        },
        update: {
          title: '投稿の更新',
          message: `##AUTHOR##さんが「##TITLE##」の投稿を更新をしました。`
        },
        remove: {
          title: '投稿の削除',
          message: `##AUTHOR##さんが「##TITLE##」の投稿を削除しました。`
        }
      }
      if (socket && socket.connected) {
        socket.on(`EMIT_POST:${cid}`, (data) => {
          const { user, action, item } = data
          this.update({ action, item })
          if (user !== this.$store.getters['author/get']('userid')) {
            let notify = notifies[action] || { title: '', message: '' }
            let authors = this.$store.getters['config/get']('authors')
            let author = authors[user] ? authors[user].name[0] : user
            let { title } = item
            this.$store.dispatch('notifier/addMessage', {
              title: notify.title,
              message: notify.message.replace('##AUTHOR##', author).replace('##TITLE##', title)
            })
          }
        })
      } else {
        setTimeout(() => {
          this.connectSocket()
        }, 5000)
      }
    },
    updateQuery: function (req) {
      const form = this.$refs.footer.getForm()
      const { view, type } = form
      const typeSlug = this.meta.types[type] ? this.meta.types[type].slug : ''
      if (this.form.view !== view) {
        this.$set(this, 'form', { view })
      }
    },
    loadLegacy: function () {
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.$refs.legacyToken.value = token
        this.$nextTick(() => {
          this.$refs.legacyForm.submit()
        })
      })
    }
  },
  computed: {
    isAuthed () {
      return this.config.status.authed
    },
    isLoading () {
      return this.config.status.loading
    },
    isEmpty () {
      return !this.store.items.length
    },
    isFullLoaded () {
      return this.store.items.length === this.store.count
    },
    getItems () {
      let items = (this.store.items && this.store.items.length) ? this.store.items : []
      return items.sort((a, b) => {
        return a.date < b.date ? 1 : -1
      })
    },
    getAuthors () {
      return this.$store.getters['config/get']('authors')
    },
    getViewType () {
      return this.form.view
    },
    printURL () {
      let cid = this.$route.params.id
      return (cid === '') ? '' : ('https://legacy.sasmango.com/sas/client/' + cid + '/cstory')
    },
    isDevMode () {
      return this.$store.getters['author/get']('dev')
    }
  }
}
</script>

<style lang="scss">
#clientRecords {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
